// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useContext } from "react";
import * as React from "react";
import { css } from "styled-components";

export interface OrderDetailsPaymentTermsStyles {
    titleText?: TypographyPresentationProps;
    termsText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const paymentTermsStyles: OrderDetailsPaymentTermsStyles = {
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};
const styles = paymentTermsStyles;

const OrderDetailsPaymentTerms = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.terms) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Terms")}
            </Typography>
            {/* XNG-Changes: KSC-1137: show terms based on translation key */}
            <Typography {...styles.termsText}>{translate(order.terms)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsPaymentTerms,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
